<template>
  <div class="select-div">
    <label class="select-label">{{ lableValue }}</label>
    <el-select 
      :model-value="modelValue" 
      clearable 
      :placeholder="placeholder" 
      :filterable="filterable"
      @change="$emit('update:modelValue', $event)">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'SelectEI',
  props: {
    lableValue: {
      type: String,
      required: false
    },
    modelValue: { // 使用 modelValue 替代 value
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false,
      default: "请选择内容"
    },
    options: {
      type: Array,
      required: true
    },
    filterable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  watch: {
    modelValue(newVal) {
      console.log("子组件值改变", newVal);
      this.$emit('SelectEI-value', newVal); // 如果需要额外的事件触发可以保留此行
    }
  },
  mounted() {
    console.log("检查传入标签", this.lableValue);
  }
};
</script>

<style scoped>
.select-div {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
}

.select-label {
  width: 80px;
  margin-right: 10px;
}
</style>